// 18 languages — covers ~75% of global Christian populations plus
// Hebrew (the language of the Old Testament & modern Israel) and the
// largest mission-field languages. Each `voice` is a BCP-47 locale
// the OpenAI/Gemini TTS engines accept for read-aloud rendering.
export const LANGUAGES = [
  { code: "en",    label: "English",    voice: "en-US", flag: "🇺🇸" },
  { code: "es",    label: "Español",    voice: "es-ES", flag: "🇪🇸" },
  { code: "fr",    label: "Français",   voice: "fr-FR", flag: "🇫🇷" },
  { code: "de",    label: "Deutsch",    voice: "de-DE", flag: "🇩🇪" },
  { code: "pt",    label: "Português",  voice: "pt-BR", flag: "🇧🇷" },
  { code: "it",    label: "Italiano",   voice: "it-IT", flag: "🇮🇹" },
  { code: "pl",    label: "Polski",     voice: "pl-PL", flag: "🇵🇱" },
  { code: "ru",    label: "Русский",    voice: "ru-RU", flag: "🇷🇺" },
  { code: "tr",    label: "Türkçe",     voice: "tr-TR", flag: "🇹🇷" },
  { code: "he",    label: "עברית",      voice: "he-IL", flag: "🇮🇱" },
  { code: "ar",    label: "العربية",    voice: "ar-SA", flag: "🇸🇦" },
  { code: "hi",    label: "हिन्दी",       voice: "hi-IN", flag: "🇮🇳" },
  { code: "zh-CN", label: "中文",        voice: "zh-CN", flag: "🇨🇳" },
  { code: "ja",    label: "日本語",      voice: "ja-JP", flag: "🇯🇵" },
  { code: "ko",    label: "한국어",       voice: "ko-KR", flag: "🇰🇷" },
  { code: "id",    label: "Indonesia",  voice: "id-ID", flag: "🇮🇩" },
  { code: "tl",    label: "Filipino",   voice: "fil-PH", flag: "🇵🇭" },
  { code: "sw",    label: "Kiswahili",  voice: "sw-KE", flag: "🇰🇪" },
];

export const VERSIONS = [
  { code: "kjv", label: "King James Version" },
  { code: "web", label: "World English Bible" },
  { code: "asv", label: "American Standard" },
];
